import NavigationService from "@ane/core/lib/services/NavigationService";
import { WORKSPACE_ID } from "@ane/core/lib/constants/QueryString.constants";
import { WindowLocation } from "@ane/core/lib/services/WindowService";
import { ROUTES, CT_PATH_PREFIX } from "../routes/Routes.constants.js";
import { FeatureExperimentRouteUtils } from "../routes/FeatureExperimentRoute.utils.js";
const generateStudioPath = (pathname) => {
  return removeCTPathPrefix(pathname);
};
const generateStudioAnalysisSubPath = (pathname) => {
  return removePathPrefix(pathname, `${ROUTES.analysis.root.location.pathname}`);
};
const removePathPrefix = (pathname, prefix) => {
  return pathname.startsWith(prefix) ? `/${pathname.substr(prefix.length)}` : pathname;
};
const removeCTPathPrefix = (pathname) => {
  return removePathPrefix(pathname, `${CT_PATH_PREFIX}/`);
};
const getRootStudioPath = (pathname, search) => {
  const result = removeCTPathPrefix(pathname);
  return NavigationService.getCustomQueryParams(result, NavigationService.omitQueryParams([WORKSPACE_ID], search));
};
const getStudioPath = (payload) => {
  const pathname = removeCTPathPrefix(payload.pathname);
  return NavigationService.getCustomQueryParams(
    `${getWorkspaceBaseUrl(payload.workspaceId)}${pathname}`,
    NavigationService.omitQueryParams([WORKSPACE_ID], WindowLocation.search)
  );
};
const navigateToFeaturePivot = (payload) => {
  NavigationService.navigateTo(FeatureExperimentRouteUtils.routes.view.getURL(payload));
};
const navigateToAudienceStagePivot = (payload) => {
  NavigationService.navigateTo(FeatureExperimentRouteUtils.routes.audienceStageView.getURL(payload));
};
const getWorkspaceBaseUrl = (workspaceId) => {
  return `${ROUTES.studioWelcome.location.pathname}/${workspaceId}`;
};
const getAnalysisPlanUrl = (payload) => {
  const { workspaceId, stepId } = payload;
  return `${getWorkspaceBaseUrl(workspaceId)}/analysis/${stepId}`;
};
export {
  generateStudioAnalysisSubPath,
  generateStudioPath,
  getAnalysisPlanUrl,
  getRootStudioPath,
  getStudioPath,
  getWorkspaceBaseUrl,
  navigateToAudienceStagePivot,
  navigateToFeaturePivot,
  removeCTPathPrefix,
  removePathPrefix
};
//# sourceMappingURL=StudioRoute.utils.js.map
